"use client";

import { TableHead, TableRow } from "@/shadcn-components/ui/table";
import {
  getWatchlistColumnWidth,
  WATCHLIST_SYMBOL_COL_WIDTH,
  watchlistTh,
} from "./watchlistTableLayout";

interface WatchlistTableHeaderProps {
  columns: string[];
}

export function WatchlistTableHeader({ columns }: WatchlistTableHeaderProps) {
  return (
    <TableRow>
      <TableHead className={`${watchlistTh} ${WATCHLIST_SYMBOL_COL_WIDTH}`}>
        Symbol
      </TableHead>
      {columns.map((column) => (
        <TableHead
          key={column}
          className={`${watchlistTh} ${getWatchlistColumnWidth(column)} text-right`}
        >
          {column}
        </TableHead>
      ))}
    </TableRow>
  );
}
